import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("dw_cookie_consent")) setShow(true);
  }, []);
  const decide = (v) => { localStorage.setItem("dw_cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4" data-testid="cookie-consent">
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-4 rounded-2xl border border-white/10 bg-[#111420]/95 p-5 backdrop-blur-xl sm:flex-row sm:items-center">
        <Cookie className="h-8 w-8 shrink-0 text-[#00F0FF]" />
        <p className="flex-1 text-sm text-slate-300">
          We use cookies to detect your region, remember your currency and improve your experience. See our <Link to="/cookies" className="text-[#00F0FF] underline">Cookie Policy</Link>.
        </p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => decide("essential")} className="rounded-xl border-white/15 bg-transparent text-slate-200 hover:bg-white/5" data-testid="cookie-essential-btn">Essential only</Button>
          <Button onClick={() => decide("all")} className="rounded-xl bg-[#00F0FF] text-[#08090E] hover:bg-[#33F3FF]" data-testid="cookie-accept-btn">Accept all</Button>
        </div>
      </div>
    </div>
  );
}
